import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { isMobile } from '../../hooks/responsive'
import RegisterCTA from '../../components/RegisterCTA'
import Section from '../../components/Section'
import DesktopBenefitsView from './DesktopBenefitsView'
import MobileBenefitsView from './MobileBenefitsView'
import intlPropTypes from '../../types/intlPropTypes'

const styles = () => ({
  sectionDesktopContainer: {
    height: '470px',
    overflow: 'none'
  },
  sectionMobileContainer: {
    height: '470px',
    position: 'relative',
    overflowY: 'hidden'
  }
})

const PureBenefitsSection = ({ classes, intl, benefitsData, ctaOnClick, isEloThemeActive, ...props }) => {
  const formattedBenefitsData = benefitsData.edges.map(
    (item, index) => ({
      ...item.node.frontmatter,
      carouselID: index
    })
    
  )
  const initialPosition = formattedBenefitsData.filter(
    item => item.isActive === true
  )[0].carouselID
  const [sections, setSections] = useState(formattedBenefitsData)

  const setMobileSectionActive = currentSlide => {
    setSections(
      sections.map(section => ({
        ...section,
        isActive: section.carouselID === currentSlide
      }))
    )
  }

  const setDesktopSectionActive = activeSection => {
    setSections(
      sections.map(section => ({
        ...section,
        isActive: section.id === activeSection.id
      }))
    )
  }

  return (
    <Section
      headingTitle={<FormattedMessage id="benefitsHeadingTitle" />}
      headingSubtitle={<FormattedMessage id="benefitsHeadingSubtitle" />}
      isEloThemeActive={isEloThemeActive}
      {...props}
    >
      <Container>
        <div
          className={
            isMobile()
              ? classes.sectionMobileContainer
              : classes.sectionDesktopContainer
          }
        >
          {isMobile() ? (
            <MobileBenefitsView
              initialPosition={initialPosition}
              sections={sections}
              setSectionActive={setMobileSectionActive}
            />
          ) : (
            <DesktopBenefitsView
              sections={sections}
              setSectionActive={setDesktopSectionActive}
            />
          )}
        </div>
        <Typography align="center" component="h2">
          <RegisterCTA
            id="benefits-register-cta-button"
            data-gtm-category="landing_beneficios"
            data-gtm-label={intl.formatMessage({
              id: 'benefitRegisterButtonText'
            })}
            data-gtm-main-action="click"
            data-testid="benefits-register-cta-button"
            label={intl.formatMessage({ id: 'benefitRegisterButtonText' })}
            isEloThemeActive={isEloThemeActive}
            href={isMobile() ? (
              intl.formatMessage({ id: 'ctaButtonLinkMobile' })
            ) : (
              intl.formatMessage({ id: 'ctaButtonLinkDesktop' })
            )}
            onClick={ctaOnClick}
          />
        </Typography>
      </Container>
    </Section>
  )
}

PureBenefitsSection.propTypes = {
  classes: PropTypes.shape({
    sectionDesktopContainer: PropTypes.string,
    sectionMobileContainer: PropTypes.string
  }),
  intl: PropTypes.shape(intlPropTypes),
  benefitsData: PropTypes.object,
  ctaOnClick: PropTypes.func,
  isEloThemeActive: PropTypes.bool
}

const BenefitsSection = withStyles(styles)(injectIntl(PureBenefitsSection))

export default BenefitsSection
